import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { z } from "zod";

const timelineReminderIdSchema = z.object({
	reminderId: z.number().nullish(),
});

// `data` is a union of six DTOs with no discriminator inside it (the shape is
// decided by the parent's category/subcategory), so TS cannot narrow it to
// TimelineReminderDataDTO — the shape is checked at runtime instead.
export const parseTimelineReminderId = (
	data: TimelineItemResponseDTO["data"],
): number | null => {
	const result = timelineReminderIdSchema.safeParse(data);
	return result.success ? (result.data.reminderId ?? null) : null;
};
